import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { fg } from '@atlaskit/platform-feature-flags';
import { Stack } from '@atlaskit/primitives';
import { messages } from '../../../../messages';
import RelatedLinksList from '../../components/related-links-list';
import RelatedLinksResolvedViewOld from './ResolvedOld';
var RelatedLinksResolvedView = function RelatedLinksResolvedView(_ref) {
  var _ref$incomingLinks = _ref.incomingLinks,
    incomingLinks = _ref$incomingLinks === void 0 ? [] : _ref$incomingLinks,
    _ref$outgoingLinks = _ref.outgoingLinks,
    outgoingLinks = _ref$outgoingLinks === void 0 ? [] : _ref$outgoingLinks;
  return /*#__PURE__*/React.createElement(Stack, {
    space: "space.150"
  }, /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: {
      component: 'relatedLinksIncoming'
    }
  }, /*#__PURE__*/React.createElement(RelatedLinksList, {
    urls: incomingLinks,
    title: messages.related_links_found_in,
    testId: "incoming-related-links-list"
  })), /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: {
      component: 'relatedLinksOutgoing'
    }
  }, /*#__PURE__*/React.createElement(RelatedLinksList, {
    urls: outgoingLinks,
    title: messages.related_links_includes_links_to,
    testId: "outgoing-related-links-list"
  })));
};
var RelatedLinksResolvedExported = function RelatedLinksResolvedExported(props) {
  if (fg('bandicoots-compiled-migration-smartcard')) {
    return /*#__PURE__*/React.createElement(RelatedLinksResolvedView, props);
  } else {
    return /*#__PURE__*/React.createElement(RelatedLinksResolvedViewOld, props);
  }
};
export default RelatedLinksResolvedExported;